import { SelectField } from '@src/shared/fields/select-field';
import { formatTextForDisplay } from '@src/shared/utils/helpers/format-text-for-display';
import type { TReminderFormValues } from './schema';
import { ErrorMessage, useFormikContext } from 'formik';
import { Textfield } from '@src/shared/fields/text-field';
import {
  REMINDER_SUBMISSION_DATE_TYPES,
  REMINDER_TRIGGER_TYPES,
} from '@src/shared/types/reminder';
import { cn } from '@src/design-system/helpers';
import { CustomErrorMessage } from '@src/design-system/error-message';
import { RadioIndicator } from '@src/design-system/radio';
import { Label } from '@src/design-system/label';

export function SubmissionDateFields() {
  const { values, setFieldValue, setFieldTouched, setTouched } =
    useFormikContext<TReminderFormValues>();

  const handleFrequencyBlur = () => {
    setFieldTouched('frequency', true);
    if (values.frequency == null || String(values.frequency) === '') {
      setFieldValue('frequency', 0, false);
    }
  };

  return (
    <div className='flex flex-col gap-4'>
      <div className='grid grid-cols-4 gap-4'>
        <div className='col-span-1'>
          <SelectField
            selectName='trigger_type'
            selectPlaceholder='Select'
            onValueChange={(value) => {
              setTouched({ frequency: false });
              setFieldValue('frequency', 0);
              setFieldValue('trigger_type', value);
            }}
            options={Object.values(REMINDER_TRIGGER_TYPES).map((t) => ({
              label: formatTextForDisplay(t),
              value: t,
            }))}
          />
        </div>

        <div className='col-span-1 overflow-visible'>
          <div className='flex items-start'>
            <div className='w-[60px] shrink-0'>
              <Textfield
                className='rounded-r-none'
                type='number'
                disabled={values.trigger_type === REMINDER_TRIGGER_TYPES.on}
                name='frequency'
                hideError
                onBlur={handleFrequencyBlur}
              />
            </div>
            <div
              className={cn(
                'flex h-12 shrink-0 items-center justify-center bg-primary-100 text-gray-800 text-sm font-medium rounded-r-lg px-3',
                values.trigger_type === REMINDER_TRIGGER_TYPES.on &&
                  'opacity-70'
              )}
            >
              Days
            </div>
          </div>
          <ErrorMessage
            name='frequency'
            component={CustomErrorMessage}
            className='whitespace-nowrap'
          />
        </div>

        <div className='flex flex-col gap-3'>
          <div
            className='flex items-center gap-2'
            onClick={() =>
              setFieldValue(
                'submission_date_type',
                REMINDER_SUBMISSION_DATE_TYPES.startDate
              )
            }
          >
            <RadioIndicator
              className='cursor-pointer'
              checked={
                values.submission_date_type ===
                REMINDER_SUBMISSION_DATE_TYPES.startDate
              }
            />

            <Label className='mb-0'>Start Date</Label>
          </div>
          <div
            className='flex items-center gap-2'
            onClick={() =>
              setFieldValue(
                'submission_date_type',
                REMINDER_SUBMISSION_DATE_TYPES.endDate
              )
            }
          >
            <RadioIndicator
              className='cursor-pointer'
              checked={
                values.submission_date_type ===
                REMINDER_SUBMISSION_DATE_TYPES.endDate
              }
            />

            <Label className='mb-0'>End Date</Label>
          </div>

          <ErrorMessage
            name='submission_date_type'
            component={CustomErrorMessage}
            className='whitespace-nowrap'
          />
        </div>
      </div>
    </div>
  );
}
